<table class="table">
  <thead>
    <tr>
      <th [ngStyle]="{ 'background': colorCabecera }" colspan="2">Dates</th>
      <th [ngStyle]="{ 'background': colorCabecera }">Cruise</th>
      <th [ngStyle]="{ 'background': colorCabecera }">Length</th>
      <th [ngStyle]="{ 'background': colorCabecera }">Avail</th>
      <th [ngStyle]="{ 'background': colorCabecera }" *ngIf="hiddenHoldSold">Hold</th>
      <th [ngStyle]="{ 'background': colorCabecera }" *ngIf="hiddenHoldSold">Sold</th>
      <th [ngStyle]="{ 'background': colorCabecera }" style="width: 20%;">Promotion*</th>
      <th [ngStyle]="{ 'background': colorCabecera }">Price pp. from</th>
      <th [ngStyle]="{ 'background': colorCabecera }">&nbsp;</th>
    </tr>
  </thead>
  <tbody>
    <ng-template ngFor let-c [ngForOf]="totalCruises" let-index="index">
      <tr>
        <!-- COLUMN DATES -->
        <td class="month_{{ c.startDate | date: 'MMM' | lowercase }}" data-title='Month:' style="vertical-align: middle"
          [ngStyle]="{'background': getColorbyMonth(c)}">
          {{ c.startDate | date: 'MMM' | uppercase }}
        </td>
        <td data-label="Dates" class="tableDays" data-title='Dates:' style="vertical-align: middle;">
          <span style="font-size: 19px;">{{ c.startDate | date: 'dd' }}-{{ c.endDate | date: 'dd' }} <small
              *ngIf="(c.startDate | date: 'MMM') != (c.endDate | date: 'MMM')"> {{ c.endDate | date: 'MMM'
              }}</small></span>
          <em>
            {{ c.startDate | date: 'EEE' | uppercase }} - {{ c.endDate | date: 'EEE' | uppercase }}
            <a (click)="openItineraryDetailsModal(c.boat, c)" style="cursor: pointer;">
              ({{ c.name }})
            </a>
          </em>
        </td>
        <!-- COLUMN CRUISE -->
        <td class="tableDays" data-label="Cruise:" style="vertical-align: middle;">
          <a href="{{c.boat.webLink}}" class="boatlnk" target="_blank" (click)="addLogDetails(c.boat.name)"> {{
            c.boat.name }}
            <div>
              <img src="assets/images/black-arrow.png" class="arrw" />
              <img lazyLoad="{{logoCruise}}{{c.boat.image }}" class="boat" alt="c.boat.imageBoat"
                defaultImage="https://dev.frontend.galavail.com/assets/images/no-disponible.gif" />
            </div>
          </a>

        </td>
        <!-- COLUMN LENGTH -->
        <td class='tblDaysCol' data-label="Length:" style="vertical-align: middle;">
          {{ c.length }}
        </td>
        <!-- COLUMN AVAIL -->
        <td class="tblDaysCol" data-label="Available:" style="vertical-align: middle;">
          <span *ngIf="c.avail == 0">{{ c.avail }}</span>
          <i class={{getClassTool(c.cabinsAvailable.length)}} *ngIf=" c.avail > 0">
            {{ c.avail }}
            <span class="tooltiptext" *ngIf="c.cabinsAvailable.length>0">
              <img src="assets/images/black-arrow.png" />
              <!--<p>Cabins available by type/deck:</p>-->
              <ul>
                <li *ngFor="let cAvail of c.cabinsAvailable"><strong>{{ cAvail}}</strong></li>

              </ul>
            </span>
          </i>
        </td>
        <!-- COLUMN HOLD -->
        <td class="tblDaysCol" data-label="Hold:" style="vertical-align: middle;" *ngIf="hiddenHoldSold">
          <span *ngIf="c.hold == 0">{{ c.hold }}</span>
          <i class={{getClassTool(c.cabinsOnHold.length)}} *ngIf="c.hold > 0">
            {{ c.hold }}
            <span class="tooltiptext" *ngIf="c.cabinsOnHold.length>0">
              <img src="../../../assets/images/black-arrow.png" />
              <!--<p>Cabins hold by type/deck:</p>-->
              <ul>
                <li *ngFor="let cOnHold of c.cabinsOnHold"><strong>{{ cOnHold }}</strong></li>

              </ul>
            </span>
          </i>
        </td>
        <!-- COLUMN SOLD -->
        <td class="tblDaysCol" data-label="Sold:" style="vertical-align: middle;" *ngIf="hiddenHoldSold">
          <span>{{ c.sold }}</span>
        </td>
        <!-- COLUMN PROMOTIONS -->
        <td class="tablePromos" data-label="Promotion:" style="vertical-align: middle;"
          [ngStyle]="{'color': colorSecundario}">
          <div *ngIf="isCharterOnly">
            <div *ngIf="c.promotionType == PROMO_NET">SPECIAL PRICE</div>
            <div *ngIf="doesAplyCharter(c.charterOnly, c.boat.passengers, c.avail)">
              {{getTextCharterRateWithFilterCharter()}}</div>
            <div *ngIf="!doesAplyCharter(c.charterOnly, c.boat.passengers, c.avail)">
              {{getTextCharterOnlyWithFilterCharter()}}</div>
            <div>{{ c.remarks | remarks }}</div>
            <div style="font-weight: 800;">{{ renderTextPromotion( c ) }}</div>
          </div>
          <div *ngIf="!isCharterOnly">
            <div *ngIf="c.promotionType == PROMO_NET">SPECIAL PRICE</div>
            <div *ngIf="c.groupsOnly">GROUPS ONLY</div>
            <div *ngIf="c.charterOnly">{{getTextCharterOnlyWithFilterCharter()}}</div>
            <div>{{ c.remarks | remarks }}</div>
            <div style="font-weight: 800;">{{ renderTextPromotion( c ) }}</div>
          </div>
          <!-- START ICONS ADITIONAL SERVICES-->
          <i class="tool" *ngIf="c.includesAirTickets">
            <i class=" icon-style fa fa-plane" data-toggle="tooltip" data-placement="bottom" title="" aria-hidden="true"
              data-original-title="Hotel Nights"></i>
            <span class="tooltiptext">
              <img src="assets/images/black-arrow.png" />
              <ul>
                <li><strong style="color: white;"> INCLUDES AIR TICKETS </strong></li>
              </ul>
            </span>
          </i>

          <i *ngIf="c.includesAirTickets && viewAditionalServices(c)" class="fa fa-plus small plus-icon"
            aria-hidden="true"></i>
          <em *ngIf="viewAditionalServices(c)">
            <i class="tool" *ngFor="let aditionalService of mapAvailabilityObj(c) ; let icont=index">
              <i class="icon-style" [ngClass]="aditionalService.icon" data-toggle="tooltip" data-placement="bottom"
                title="" aria-hidden="true" data-original-title="Hotel Nights"></i>
              <span class="tooltiptext">
                <img src="assets/images/black-arrow.png" />
                <ul>
                  <li><strong style="color: white;"> {{aditionalService.textValue}}</strong></li>
                </ul>
              </span>
              <i *ngIf=" (icont+1)< mapAvailabilityObj(c).length" class="fa fa-plus small plus-icon"
                aria-hidden="true"></i>
            </i>
          </em>

          <!-- END ICONS ADITIONAL SERVICES-->


        </td>
        <!-- COLUMN PRICES -->
        <td data-label="Price from:" class="tablePrice" style="vertical-align: middle;">
          <!-- IS SEARCHED CHARTER ONLYS -->
          <div *ngIf="isCharterOnly">


            <!--Valor Original para Charter-->
            <div class="was"
              *ngIf="c.charterPrice != c.charterPricePromo  && c.charterPromotionType != PROMO_RAC && c.charterPromotionType != PROMO_NET">
              US$ {{ c.charterPrice | number:'3.0-0' }}
            </div>

            <!--Valor Charter Promo-->
            <div id="priceCharter" *ngIf="c.charterPromotionType != PROMO_RAC && c.charterPromotionType != PROMO_NET">
              US$ {{ c.charterPricePromo | number:'3.0-0' }}
            </div>
            <!--Valor Charter Rack-->
            <div *ngIf="(c.charterPromotionType == PROMO_RAC || c.charterPromotionType == PROMO_NET) ">
              US$ {{ c.charterPrice | number:'3.0-0' }}
            </div>
          </div>
          <!-- IS SEARCHED DEFAULT OPTIONS -->
          <div *ngIf="!isCharterOnly">

            <!--Valor Original por Persona-->
            <div class="was"
              *ngIf="c.promotionPrice != c.rackPrice && !c.charterOnly && c.promotionType != PROMO_RAC && c.promotionType != PROMO_NET">
              US$ {{ c.rackPrice | number:'3.0-0' }}
            </div>
            <!--Valor Original para Charter-->
            <div class="was"
              *ngIf="c.charterPrice != c.charterPricePromo && c.charterOnly && c.promotionType != PROMO_RAC && c.promotionType != PROMO_NET">
              US$ {{ c.charterPrice | number:'3.0-0' }}
            </div>
            <!--Valor por Persona-->
            <div *ngIf="!c.charterOnly" class="tool-withouttiptext">
              <span *ngIf="c.cabinsAvailablePrices?.length == 0">US$ {{ c.promotionPrice | number:'3.0-0' }}</span>
              <span class="tool" *ngIf="c.cabinsAvailablePrices?.length !== 0">
                US$ {{ c.promotionPrice | number:'3.0-0' }}
                <span class="tooltiptext" style="min-width: 300px;">
                  <img src="assets/images/black-arrow.png" />
                  <ul>
                    <li *ngFor="let pr of c.cabinsAvailablePrices"><strong>{{pr}} </strong></li>
                  </ul>
                </span>
              </span>
            </div>
            <!--Valor Charter Promo-->
            <div id="priceCharter"
              *ngIf="c.charterPromotionType != PROMO_RAC && c.charterPromotionType != PROMO_NET && c.charterOnly ">
              US$ {{ c.charterPricePromo | number:'3.0-0' }}
            </div>
            <!--Valor Charter Rack-->
            <div id="priceCharterRack"
              *ngIf="(c.charterPromotionType == PROMO_RAC || c.charterPromotionType == PROMO_NET) && c.charterOnly">
              US$ {{ c.charterPrice | number:'3.0-0' }}
            </div>
          </div>

        </td>
        <!-- COLUMN OPTIONS -->
        <td class="tblInquireCol" style="vertical-align: middle;">
          <a *ngIf="datesCompany.visibleInquire && !isCharterOnlyOrSearchedCharter(c)"
            href="{{ empresa }}/inquire/{{ dataCodeEncrypt }}/{{ c.code }}/fit/1" class="inq"
            [ngStyle]="{ 'background-color': colorSecundario }"
            (click)="setParametersInquire( c.code, empresa, c.boat.name, renderTextPromotion(c), isCharterOnlyOrSearchedCharter(c) ? 'Charter' : 'none',
            isCharterOnlyOrSearchedCharter(c) ? c.charterPrice : c.rackPrice, isCharterOnlyOrSearchedCharter(c) ? c.charterPricePromo : c.promotionPrice, c.startDate,
             c.endDate, c.length, c.name, passengers, c.startEndDates, c.boat.logo, c.boat.image, c.aditionalServices); isVisibleDialog=false;  setSelectedOption(c.boat, 'c')">Inquire
            Here</a>
          <a *ngIf="datesCompany.visibleInquire && isCharterOnlyOrSearchedCharter(c)"
            href="{{ empresa }}/inquire/{{ dataCodeEncrypt }}/{{ c.code }}/charter/0" class="inq"
            [ngStyle]="{ 'background-color': colorSecundario }"
            (click)="setParametersInquire( c.code, empresa, c.boat.name, renderTextPromotion(c), isCharterOnlyOrSearchedCharter(c) ? 'Charter' : 'none',
            isCharterOnlyOrSearchedCharter(c) ? c.charterPrice : c.rackPrice, isCharterOnlyOrSearchedCharter(c) ? c.charterPricePromo : c.promotionPrice, c.startDate,
             c.endDate, c.length, c.name, passengers, c.startEndDates, c.boat.logo, c.boat.image, c.aditionalServices); isVisibleDialog=false;  setSelectedOption(c.boat, 'c')">Inquire
            Here</a>

          <a (click)="setParametersInquire( c.code, empresa, c.boat.name, renderTextPromotion(c), isCharterOnlyOrSearchedCharter(c) ? 'Charter' : 'none',
                         isCharterOnlyOrSearchedCharter(c) ? c.charterPrice : c.rackPrice, isCharterOnlyOrSearchedCharter(c) ? c.charterPricePromo : c.promotionPrice, c.startDate,
                          c.endDate, c.length, c.name, passengers, c.startEndDates, c.boat.logo, c.boat.image, c.aditionalServices); isVisibleDialog=true;  setSelectedOption(c.boat, c)"
            *ngIf="(((datesCompany.visibleEcommerce||datesCompany.visibleOnHold) && validateBookNowButton(c.boat, c)) || (datesCompany.visibleEcommerce||datesCompany.visibleOnHold) && isVisibleOnhold(c)) && !doesAplyCharter(isCharterOnlyOrSearchedCharter(c), c.boat.passengers, c.avail)
                        && !isCharterOnlyOrSearchedCharter(c)" style="cursor: pointer;" class="sml">RESERVE NOW</a>
        </td>
      </tr>
      <tr *ngIf="doesAplyCharterOption(c.charterOnly, c.boat.passengers, c.avail , c ) && c.charterPrice!=0">
        <!-- COLUMN DATES -->
        <td class="month_{{ c.startDate | date: 'MMM' | lowercase }}" data-title='Month:'
          style="vertical-align: middle;" [ngStyle]="{'background': getColorbyMonth(c)}">
          {{ c.startDate | date: 'MMM' | uppercase }}</td>
        <td data-label="Dates" class="tableDays" data-title='Dates:' style="vertical-align: middle;">
          <span style="font-size: 19px;">{{ c.startDate | date: 'dd' }}-{{ c.endDate | date: 'dd' }} <small
              *ngIf="(c.startDate | date: 'MMM') != (c.endDate | date: 'MMM')"> {{ c.endDate | date: 'MMM'
              }}</small></span>
          <em>
            {{ c.startDate | date: 'EEE' | uppercase }} - {{ c.endDate | date: 'EEE' | uppercase }}
            <a (click)="openItineraryDetailsModal(c.boat, c)" style="cursor: pointer;">
              ({{ c.name }})
            </a>
          </em>
        </td>
        <!-- COLUMN CRUISE -->
        <td class="tableDays" data-label="Cruise:" style="vertical-align: middle;">
          <a href="{{c.boat.webLink}}" class="boatlnk" target="_blank" (click)="addLogDetails(c.boat.name)"> {{
            c.boat.name }}
            <div>
              <img src="assets/images/black-arrow.png" class="arrw" />
              <img lazyLoad="{{logoCruise}}{{c.boat.image }}" class="boat" alt="c.boat.imageBoat"
                defaultImage="https://dev.frontend.galavail.com/assets/images/no-disponible.gif" />
            </div>
          </a>
        </td>
        <!-- COLUMN LENGTH -->
        <td class='tblDaysCol' data-label="Length:" style="vertical-align: middle;">
          {{ c.length }}
        </td>
        <!-- COLUMN AVAIL -->
        <td class="tblDaysCol" data-label="Available:" style="vertical-align: middle;">
          <span *ngIf="c.avail == 0">{{ c.avail }}</span>
          <i class={{getClassTool(c.cabinsAvailable.length)}} *ngIf=" c.avail > 0">
            {{ c.avail }}
            <span class="tooltiptext" *ngIf="c.cabinsAvailable.length>0">
              <img src="assets/images/black-arrow.png" />
              <!--<p>Cabins available by type/deck:</p>-->
              <ul>
                <li *ngFor="let cAvail of c.cabinsAvailable"><strong>{{ cAvail}}</strong></li>
              </ul>
            </span>
          </i>
        </td>
        <!-- COLUMN HOLD -->
        <td class="tblDaysCol" data-label="Hold:" style="vertical-align: middle;">
          <span *ngIf="c.hold == 0">{{ c.hold }}</span>
          <i class={{getClassTool(c.cabinsOnHold.length)}} *ngIf="c.hold > 0">
            {{ c.hold }}
            <span class="tooltiptext" *ngIf="c.cabinsOnHold.length>0">
              <img src="../../../assets/images/black-arrow.png" />
              <!--<p>Cabins hold by type/deck:</p>-->
              <ul>
                <li *ngFor="let cOnHold of c.cabinsOnHold"><strong>{{ cOnHold }}</strong></li>
              </ul>
            </span>
          </i>
        </td>
        <!-- COLUMN SOLD -->
        <td class="tblDaysCol" data-label="Sold:" style="vertical-align: middle;">
          <span>{{ c.sold }}</span>
        </td>
        <!-- COLUMN PROMOTIONS -->
        <td class="tablePromos" data-label="Promotion:" style="vertical-align: middle;"
          [ngStyle]="{'color': colorSecundario}">
          <div>
            <div *ngIf="c.charterPromotionType == PROMO_NET">SPECIAL PRICE</div>
            <div>{{getTextCharterRateWithFilterCharter()}}</div>
            <div>{{ c.remarks | remarks }}</div>
            <div style="font-weight: 800;" *ngIf="c.charterPromotionType != PROMO_RAC">{{ renderTextPromotion( c, true )
              }}</div>
          </div>
          <!-- START ICONS ADITIONAL SERVICES-->
          <i class="tool" *ngIf="c.includesAirTickets">
            <i class=" icon-style fa fa-plane" data-toggle="tooltip" data-placement="bottom" title="" aria-hidden="true"
              data-original-title="Hotel Nights"></i>
            <span class="tooltiptext">
              <img src="assets/images/black-arrow.png" />
              <ul>
                <li><strong style="color: white;"> INCLUDES AIR TICKETS </strong></li>
              </ul>
            </span>
          </i>
          <i *ngIf="c.includesAirTickets && viewAditionalServices(c)" class="fa fa-plus small plus-icon"
            aria-hidden="true"></i>
          <em *ngIf="viewAditionalServices(c)">
            <i class="tool" *ngFor="let aditionalService of mapAvailabilityObj(c) ; let icont=index">
              <i class="icon-style" [ngClass]="aditionalService.icon" data-toggle="tooltip" data-placement="bottom"
                title="" aria-hidden="true" data-original-title="Hotel Nights"></i>
              <span class="tooltiptext">
                <img src="assets/images/black-arrow.png" />
                <ul>
                  <li><strong style="color: white;"> {{aditionalService.textValue}}</strong></li>
                </ul>
              </span>
              <i *ngIf=" (icont+1)< mapAvailabilityObj(c).length" class="fa fa-plus small plus-icon"
                aria-hidden="true"></i>
            </i>
          </em>
          <!-- END ICONS ADITIONAL SERVICES-->
        </td>
        <!-- COLUMN PRICES -->
        <td data-label="Price from:" class="tablePrice" style="vertical-align: middle;">
          <!-- IS SEARCHED CHARTER ONLYs -->
          <div class="price">
            <!--Valor Original para Charter-->
            <div class="was"
              *ngIf="c.charterPrice != c.charterPricePromo  && c.charterPromotionType != PROMO_RAC && c.charterPromotionType != PROMO_NET">
              US$ {{ c.charterPrice | number:'3.0-0' }}
            </div>
            <!--Valor Charter Promo-->
            <div id="priceCharter" *ngIf="c.charterPromotionType != PROMO_RAC && c.charterPromotionType != PROMO_NET">
              US$ {{ c.charterPricePromo | number:'3.0-0' }}
            </div>
            <!--Valor Charter Rack-->
            <div *ngIf="(c.charterPromotionType == PROMO_RAC || c.charterPromotionType == PROMO_NET) ">
              US$ {{ c.charterPrice | number:'3.0-0' }}
            </div>
          </div>
        </td>
        <!-- COLUMN OPTIONS -->
        <td class="tblInquireCol" style="vertical-align: middle;">
          <a *ngIf="datesCompany.visibleInquire"
            href="{{ empresa }}/inquire/{{ dataCodeEncrypt }}/{{ c.code }}/charter/0" class="inq"
            [ngStyle]="{ 'background-color': colorSecundario }"
            (click)="setParametersInquire( c.code, empresa, c.boat.name, renderTextPromotion(c), isCharterOnlyOrSearchedCharter(c) ? 'Charter' : 'none',
            isCharterOnlyOrSearchedCharter(c) ? c.charterPrice : c.rackPrice, isCharterOnlyOrSearchedCharter(c) ? c.charterPricePromo : c.promotionPrice, c.startDate,
             c.endDate, c.length, c.name, passengers, c.startEndDates, c.boat.logo, c.boat.image, c.aditionalServices); isVisibleDialog=false;  setSelectedOption(c.boat, 'c')">Inquire
            Here</a>
        </td>
      </tr>
    </ng-template>
  </tbody>
</table>

<gal-modal *ngIf="selectedAvailability && selectedCruise" [visible]="isVisibleDialog" [closable]="true"
  [modalWidth]="'30vw'" (modalClosed)="isVisibleDialog=false; visibleAlertText= false">
  <div class="content-modal">
    <div class="title-modal">
      <h3> I want to:</h3>
    </div>
    <div class="message-modal">
      <div class="container">
        <div class="row" style="display: flex;">
          <div class="col-sm"
            *ngIf="(datesCompany.visibleEcommerce && validateBookNowButton(selectedCruise, selectedAvailability))">
            <a class="inq ng-star-inserted buttonBookNow" style="  width: 114px;  text-align: center;" id="buttonShare"
              [ngStyle]="{ 'background-color': colorSecundario }"
              href="{{ env.pathEcommerceGalavail }}/{{ empresa }}/{{ selectedCode }}/{{ passengers }}/{{ dataCodeEncrypt }}{{isAllSearch ? '/all':''}}">
              <b>
                Book and Pay now
              </b>
            </a>
          </div>
          <div class="col-sm">
            <a class="inq ng-star-inserted buttonBookNow" style="width: 114px;  text-align: center;" id="buttonPlace"
              [ngStyle]="{ 'background-color': colorSecundario }" (click)="goAndValidateOnhold(selectedAvailability)"
              *ngIf="datesCompany.visibleOnHold">
              <b>
                Place on Hold
              </b>
            </a>
          </div>
        </div>
        <br>
        <div class="w3-panel w3-pale-red w3-border" id="alert-design" *ngIf="visibleAlertText">
          {{textAlart}} <br>
          <br>
          <a (click)="visibleAlertText = false" style="cursor: pointer;
                    text-align: center;
                    width: fit-content;" [ngStyle]="{ 'background-color': colorSecundario }"> Accept</a>
        </div>
      </div>
    </div>
  </div>
</gal-modal>

<gal-modal [visible]="isVisibleDialogItinerary" [closable]="true" [modalWidth]="'55rem'"
  *ngIf="isVisibleDialogItinerary" (modalClosed)="isVisibleDialogItinerary=false">
  <ng-container *ngIf="loadingItineryDetail">
    <app-loading-itinerary-details></app-loading-itinerary-details>
    <!-- <div _ngcontent-hmy-c5="" class="headmod" id="idHeader"[ngStyle]="{ 'background-color': colorSecundario, 'color': '#fff' }" >
     loading ...
    </div> -->
  </ng-container>
  <ng-container *ngIf="!loadingItineryDetail">
    <div _ngcontent-hmy-c5="" class="headmod" id="idHeader"
      [ngStyle]="{ 'background-color': colorCabecera, 'color': '#fff' }">
      {{selectedAvailability.length}}- Itinerary: {{ selectedAvailability.startDate | date: 'EEE' | uppercase }} - {{
      selectedAvailability.endDate | date: 'EEE' | uppercase }} {{itinerarySelect.length}}({{itinerarySelect.name}})
    </div>
    <div class="content-modal" style="display: flex;">
      <div style="flex: 2;">
        <h4>
          {{ selectedAvailability.startDate | date: 'MMM' }} {{ selectedAvailability.startDate | date: 'dd' }}-{{
          selectedAvailability.endDate | date: 'dd' }}, {{ selectedAvailability.startDate | date: 'y' }}
        </h4>
        <app-itinerary-details [itineraries]="this.itineraries" [className]="'tab-itinerary'" style="width: 100%;"
          [isIncludeTableHeader]="false" [itineraryDescription]="this.itinerarySelect.description"></app-itinerary-details>
      </div>
      <div style="flex: 1;">
        <img class="img-fluid mb-3"
          [src]="this.itinerarySelect.images.length > 0 ?(imgItinerariesResourceUrl + this.itinerarySelect.images[ 0 ]) : null"
          width="400" height="300" alt="image">
      </div>
    </div>
    <div class="content-modal" style="display: flex; color: #fff;justify-content: end;">
      <button [ngStyle]="{ 'background-color': colorSecundario }" color="white" mat-button
        (click)="isVisibleDialogItinerary=false">
        Accept
      </button>
    </div>
  </ng-container>
</gal-modal>